import { createSlice } from '@reduxjs/toolkit';
import {
    fetchPackagingUnits,
    addPackagingUnit,
    updatePackagingUnit,
    deletePackagingUnit,
    addPackagingUnitComponent,
    updatePackagingUnitComponent,
    deletePackagingUnitComponent,
    addPackagingUnitDocument,
    deletePackagingUnitDocument,
    setPackagingUnitConformityAssessment,
    setPackagingUnitConformityAssessments,
    setPackagingUnitStandardsAssessments,
    setPackagingUnitDrawingDocument,
    setDistributorVerification,
    setProducerVerification,
    setPackagingUnitPublicPage,
    generatePackagingUnitQrCode,
    fetchConformityMeta,
    deleteTechnicalDocumentationGeneration,
    deleteEuDeclarationGeneration,
    confirmPackagingUnitSupplierDocs,
    setPackagingUnitArchived,
} from '../actions/packagingUnit';

const replaceUnit = (state, unit) => {
    const idx = state.data.findIndex(u => u._id === unit._id);
    if (idx !== -1) state.data[idx] = unit;
};

export const packagingUnitSlice = createSlice({
    name: 'packagingUnit',
    initialState: {
        loading: false,
        data: [],
        addedUnit: null,
        conformityStatusOptions: [],
    },
    reducers: {
        updateUnit: (state, action) => { replaceUnit(state, action.payload); },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPackagingUnits.pending, (state) => { state.loading = true; })
            .addCase(fetchPackagingUnits.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPackagingUnits.rejected, (state) => { state.loading = false; })

            .addCase(addPackagingUnit.pending, (state) => { state.loading = true; })
            .addCase(addPackagingUnit.fulfilled, (state, action) => {
                state.loading = false;
                state.addedUnit = action.payload;
            })
            .addCase(addPackagingUnit.rejected, (state) => { state.loading = false; })

            .addCase(updatePackagingUnit.pending, (state) => { state.loading = true; })
            .addCase(updatePackagingUnit.fulfilled, (state) => { state.loading = false; })
            .addCase(updatePackagingUnit.rejected, (state) => { state.loading = false; })

            .addCase(deletePackagingUnit.pending, (state) => { state.loading = true; })
            .addCase(deletePackagingUnit.fulfilled, (state) => { state.loading = false; })
            .addCase(deletePackagingUnit.rejected, (state) => { state.loading = false; })

            .addCase(addPackagingUnitComponent.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(updatePackagingUnitComponent.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(deletePackagingUnitComponent.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(addPackagingUnitDocument.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(deletePackagingUnitDocument.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setPackagingUnitConformityAssessment.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setPackagingUnitConformityAssessments.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setPackagingUnitStandardsAssessments.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setPackagingUnitDrawingDocument.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setDistributorVerification.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setProducerVerification.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setPackagingUnitPublicPage.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(generatePackagingUnitQrCode.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(deleteTechnicalDocumentationGeneration.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(deleteEuDeclarationGeneration.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(fetchConformityMeta.fulfilled, (state, action) => { state.conformityStatusOptions = action.payload.statusOptions; })
            .addCase(confirmPackagingUnitSupplierDocs.fulfilled, (state, action) => { replaceUnit(state, action.payload); })
            .addCase(setPackagingUnitArchived.fulfilled, (state, action) => { replaceUnit(state, action.payload); });
    },
});

export const { updateUnit } = packagingUnitSlice.actions;
export default packagingUnitSlice.reducer;
